// Official "Scheda assaggio" of the Aceto Balsamico Tradizionale di Modena D.O.P. (docs/schema-v2.md, ABTM section).
// The taster picks ONE of five levels per element; each level carries fixed points; the total is out of 400.
// The level descriptors are the official Italian terms: they are deliberately NOT translated.
// Field names are the API columns (levels 1 = best ... 5 = worst, null = not chosen).

export const ABTM_PROTOCOLS = ['abtm_dop', 'research_profile'];

const VISUAL = [20, 16, 12, 8, 4];
const OLFACTORY = [30, 24, 18, 12, 6];
const GUSTATORY = [36, 29, 22, 15, 8];
const FINAL = [40, 32, 24, 16, 8];

export const ABTM_ELEMENTS = [
  { field: 'abtm_density', group: 'visual', points: VISUAL, descriptors: ['sciropposa consistente', 'sciropposa scorrevole', 'fluida eccessiva', 'sciolta', 'inconsistente'] },
  { field: 'abtm_colour', group: 'visual', points: VISUAL, descriptors: ['bruno carico intenso', 'bruno carico', 'bruno', 'bruno scarico', 'ambrato'] },
  { field: 'abtm_clarity', group: 'visual', points: VISUAL, descriptors: ['intensa e brillante', 'evidente', 'leggermente velata', 'velata', 'torbida'] },
  { field: 'abtm_frankness', group: 'olfactory', points: OLFACTORY, descriptors: ['elevata', 'netta', 'discreta', 'mediocre', 'difettosa'] },
  { field: 'abtm_finesse', group: 'olfactory', points: OLFACTORY, descriptors: ['eccellente', 'gradevole', 'moderata', 'scarsa', 'mancante'] },
  { field: 'abtm_olfactory_intensity', group: 'olfactory', points: OLFACTORY, descriptors: ['ampie e prolungate', 'pronunciate', 'lievi', 'deboli e corte', 'sfuggente'] },
  { field: 'abtm_olfactory_acidity', group: 'olfactory', points: OLFACTORY, descriptors: ['elevata ed equilibrata', 'buona', 'moderata o sovverchiante', 'debole o pungente', 'carente'] },
  { field: 'abtm_fullness', group: 'gustatory', points: GUSTATORY, descriptors: ['corposa', 'consistente', 'moderata', 'limitata', 'carente'] },
  { field: 'abtm_gustatory_intensity', group: 'gustatory', points: GUSTATORY, descriptors: ['ampia', 'pronunciata', 'tenue', 'scarsa', 'mancante'] },
  { field: 'abtm_flavour', group: 'gustatory', points: GUSTATORY, descriptors: ['squisito', 'pregiato', 'gradevole', 'comune', 'sgradevole'] },
  { field: 'abtm_gustatory_acidity', group: 'gustatory', points: GUSTATORY, descriptors: ['elevata ed equilibrata', 'buona', 'moderata o sovverchiante', 'debole o pungente', 'carente'] },
  { field: 'abtm_harmony', group: 'gustatory', points: GUSTATORY, descriptors: ['matura ed amalgamata', 'equilibrata', 'non equilibrata', 'scarsa', 'assente'] },
  { field: 'abtm_final', group: 'final', points: FINAL, descriptors: null },   // the sheet prints no descriptors here
];

export const ABTM_FIELDS = ABTM_ELEMENTS.map((e) => e.field);
export const ABTM_GROUPS = ['visual', 'olfactory', 'gustatory', 'final'];
export const ABTM_MAX_TOTAL = 400;

const isLevel = (v) => Number.isInteger(Number(v)) && Number(v) >= 1 && Number(v) <= 5 && v !== '' && v !== null && v !== undefined;

// Points of one element for a level (null when not chosen)
export function abtmPoints(element, level) {
  return isLevel(level) ? element.points[Number(level) - 1] : null;
}

// Live result: points per element, how many elements are chosen and the total (only when all 13 are chosen)
export function abtmResult(values) {
  const points = {};
  let chosen = 0;
  let sum = 0;
  ABTM_ELEMENTS.forEach((el) => {
    const p = abtmPoints(el, values[el.field]);
    points[el.field] = p;
    if (p !== null) { chosen += 1; sum += p; }
  });
  return { points, chosen, count: ABTM_ELEMENTS.length, total: chosen === ABTM_ELEMENTS.length ? sum : null };
}
